<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { useProfileStore } from '~/stores/profileState'

/** Frame for the premium/checkout page. Same chrome, optional back link. */
const { t } = useI18n()
const router = useRouter()
const profileStore = useProfileStore()
const { checkPremiumStatus } = usePremiumStatus()

const showError500 = ref(false)

// Injektujeme hodnotu z error-handler pluginu
const nuxtApp = useNuxtApp()
nuxtApp.vueApp.provide('showError500', showError500)

// Handler pro zkušení opětovného načtení stránky
function _handleRetry() {
  showError500.value = false
  window.location.reload()
}

const props = defineProps({
  showBackButton: {
    type: Boolean,
    default: true
  }
})

const shouldShowBackButton = computed(() => {
  return props.showBackButton && !profileStore.isProfileIncomplete
})

/*
 * The presell offer (50 % off the monthly subscription) is retired together with
 * the monthly plan itself; a cancelled-on-day-one subscription undercut the
 * Job Search Pack. The injections stay so child components keep working.
 */
const { wasSpecialOfferShown } = usePremiumModals()

provide('showPresellModal', () => {})
provide('getPresellState', async () => ({
  presellShown: await wasSpecialOfferShown(),
  bubbleVisible: false,
}))

onMounted(async () => {
  await checkPremiumStatus()
})
</script>

<template>
  <div class="sofax flex min-h-screen flex-col bg-white dark:bg-gray-950">
    <AppNavbar />
    <main class="grow">
      <div v-if="shouldShowBackButton" class="shell pt-6">
        <button
          type="button"
          class="inline-flex items-center gap-2 text-sm font-semibold text-muted transition-colors hover:text-ink dark:text-gray-400 dark:hover:text-white"
          @click="router.back()"
        >
          <i class="bi bi-arrow-left" />
          {{ t('common.backButton') }}
        </button>
      </div>
      <slot />
    </main>
    <AppFooter />

    <!-- Chat Widget -->
    <LazyIdleCommonChatWidget hydrate-on-idle />
  </div>
</template>
